export default {
    "mapas_grid": {
        "listado_mapas": "Llistat de mapes",
        "buscar_mapa": 'Cercar mapa...',
        "sin_resultados": "No s'ha trobat cap mapa",
        "categoria_escenarios": "Escenaris",
        "categoria_otros": "Temàtiques",
    },
    "capas_grid": {
        "listado_capas": "Llistat de capes",
        "buscar_capa": 'Cercar capa...',
        "sin_resultados": "No s'ha trobat cap capa",
    },
    "paginacion": {
        "anterior": "Anterior",
        "siguiente": "Següent",
    },
    "sugerencias": {
        "campos": {
            "nombre": "Nom",
            "apellidos": "Cognoms",
            "email": "Adreça electrònica",
            "telefono": "Telèfon",
            "asunto": "Assumpte",
            "mensaje": "Missatge",
        },
        "enviar_sugerencia": "Enviar suggeriment",
        "enviado_sugerencia": "Enviant suggeriment...",
        "sugerencia_enviada_titulo": "Suggeriment enviat!",
        "sugerencia_error_titulo": "Error al enviar el suggeriment",
    },
    "catalogo": {
        "acceder_al_catalogo": "Accedir al catàleg",
        "descripcion": "És possible accedir a l'aplicació web del servei de Catàleg amb l'objectiu de realitzar consultes i accessos als serveis interoperables d'informació\n" +
            "geogràfica desenvolupats en les especificacions de l'Open Geospatial Consortium (<a href=\"http://www.opengeospatial.org/\" target=\"_blank\">OGC</a>). El servei de Catàleg disposa de tecnologia Geonode i \n" +
            "permet als usuaris la localització de serveis web mitjançant cerques en la base de dades.",
        "direccion_servei": "Adreça d'accés al servei",
        "descripcio_servei": "Descripció del servei",
        "wms_titulo": "Servei web de mapes – <b>WMS</b> - Visualització",
        "wms_descripcion": "El protocol <b><a href=\"https://www.opengeospatial.org/standards/wms\" target=\"_blank\">WMS</a></b> és un servei estàndard definit " +
            "per l'Open Geospatial Consortium (<b><a href=\"http://www.opengeospatial.org/\" target=\"_blank\">OGC</a></b>) amb l’objecte de produir mapes de forma " +
            "dinàmica a partir d'informació geogràfica. Aquest estàndard defineix un «mapa» com una representació de la informació geogràfica en forma " +
            "d'arxiu d'imatge digital. Els mapes produïts per WMS  es generen normalment en un format d'imatge com PNG o JPEG i poden ser invocats per " +
            "qualsevol protocol web o software capacitat per a la visualització d’aquests tipus de serveis.",
        "csw_titulo": "Servei de catàleg – <b>CSW</b> - Consulta",
        "csw_descripcion": "El servei Catalog Service for the Web (<b><a href=\"https://www.opengeospatial.org/standards/cat\" target=\"_blank\">CSW</a></b>)  és un " +
            "estàndard definit per l'Open Geospatial Consortium (<b><a href=\"http://www.opengeospatial.org/\" target=\"_blank\">OGC</a></b>) amb l'objectiu de definir les interfícies per la recuperació, captura i consulta de " +
            "metadades sobre les mateixes dades. Permet la cerca d'informació geogràfica d'origens diversos i temàtica variada de manera que l'usuari puga " +
            "localitzar informació geogràfica utilitzant les operacions habilitades a tal efecte.",
        "wfs_titulo": "Servei de catàleg – <b>WFS</b> - Descàrrega",
        "wfs_descripcion": "El servei Web Feature Service (<b><a href=\"https://www.opengeospatial.org/standards/wfs\" target=\"_blank\">WFS</a></b>) està definit " +
            "per l'Open Geospatial Consortium (<b><a href=\"http://www.opengeospatial.org/\" target=\"_blank\">OGC</a></b>) amb l'objecte de proporcionar la informació relativa a l'entitat emmagatzemada en una cobertura vectorial " +
            "que reuneixen les característiques formulades en la consulta. És un servei estàndard, que ofereix una interfície de comunicació que permet " +
            "interactuar amb els mapes servits per l'estàndard <b>WMS</b>, com per exemple, editar la imatge que ens ofereix el servei <b>WMS</b> o analitzar la imatge " +
            "seguint criteris geogràfics. L'Ajuntament de Vinaròs implementa aquest servei mitjançant GeoServer.",
        "catalogo_desactivado": "Temporalment estan deshabilitats els serveis del catàleg. No obstant això pots posar-te en contacte amb nosaltres a través del formulari de suggeriment o info@sigogestion.com. Si necessites que et facilitem alguna capa o accés al servei. En breu tornaràs a estar operatius. Disculpa les molèsties",
    }
}

